<div class="header__wrapper js-header js-select-dispatch no-print"><!--start_new_eyebrow-->
  <div class="top-navigation">
    <div class="content">
      <div class="top-navigation-container">
        <div class="top-navigation-container__left">
          <div class="sites-link" aria-label="S&amp;P Global Divisions">
            <a href="javascript:void(0);" aria-haspopup="true" id="division" aria-expanded="false"
               class="sites-link__cta"
               lang="en-us" (click)="toggleDropdowns('openSiteLinkDropdown')">S&amp;P Dow Jones Indices</a>
            <div class="sites-link__dropdown" aria-hidden="true" style="top: 33px;"
                 [ngStyle]="{'display': openSiteLinkDropdown ? 'block' : 'none'}">
              <div class="content"><!--start_division_heading--> <p></p><!--end_division_heading-->
                <ul class="sites-link__links" role="menu">
                  <li role="menuitem"><a href="https://www.spglobal.com/en/" data-gtm-category="Header" data-gtm-action="Outbound Link_Division"
                                         data-divison="indices" rel="spdji" data-gtm-label="S&amp;P Global" class=""
                                         lang="en-us">S&amp;P Global </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/spdji/en/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Dow Jones Indices" class="active" lang="en-us">S&amp;P
                    Dow Jones Indices </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/engineering/en/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Global Engineering Solutions" class="" lang="en-us">S&amp;P
                    Global Engineering Solutions </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/marketintelligence/en/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Global Market Intelligence" class="" lang="en-us">S&amp;P
                    Global Market Intelligence </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/mobility/en/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Global Mobility" class="" lang="en-us">S&amp;P Global
                    Mobility </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/commodity-insights/en/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Global Commodity Insights" class="" lang="en-us">S&amp;P
                    Global Commodity Insights </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/ratings/en/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Global Ratings" class="" lang="en-us">S&amp;P Global
                    Ratings </a></li>
                  <li role="menuitem"><a href="https://www.spglobal.com/esg/" data-gtm-category="Header"
                                         data-gtm-action="Outbound Link_Division" data-divison="indices" rel="spdji"
                                         data-gtm-label="S&amp;P Global Sustainable1" class="" lang="en-us">S&amp;P
                    Global Sustainable1 </a></li>
                </ul>
                <div class="sites-link__close"><a href="javascript:void(0);" lang="en-us" (click)="toggleDropdowns('openSiteLinkDropdown')"><i class="fa fa-times"></i>Close</a>
                </div>
              </div>
            </div>
          </div>
          <span class="sites-link__info">Discover more about S&amp;P Global's offerings</span></div>
        <div class="top-navigation-container__right"><!--start_language_block-->
          <div class="utility-dropdown" aria-label="Language Dropdown">
            <a href="javascript:void(0);" aria-haspopup="true" aria-label="English" aria-expanded="false"
               class="linkCta"
               lang="en-us" (click)="toggleDropdowns('openLangDropdown')">English</a>
            <ul aria-hidden="true" class="utility-dropdown-data language" role="menu"
                [ngStyle]="{'display': openLangDropdown ? 'block': 'none'}">
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/es/" aria-label="Español (Spanish)" data-gtm-category="Header"
                                     data-gtm-action="Click" data-gtm-label="Language_Español (Spanish)" lang="en-us">Español
                (Spanish)</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/pt/" aria-label="Português (Portuguese)" data-gtm-category="Header"
                                     data-gtm-action="Click" data-gtm-label="Language_Português (Portuguese)"
                                     lang="en-us">Português (Portuguese)</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/kr/" aria-label="한국어 (Korean)" data-gtm-category="Header"
                                     data-gtm-action="Click" data-gtm-label="Language_한국어 (Korean)" lang="en-us">한국어
                (Korean)</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/zh/" aria-label="简体中文 (Simplified Chinese)" data-gtm-category="Header"
                                     data-gtm-action="Click" data-gtm-label="Language_简体中文 (Simplified Chinese)"
                                     lang="en-us">简体中文 (Simplified Chinese)</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/tc/" aria-label="繁體中文 (Traditional Chinese)"
                                     data-gtm-category="Header" data-gtm-action="Click"
                                     data-gtm-label="Language_繁體中文 (Traditional Chinese)" lang="en-us">繁體中文 (Traditional
                Chinese)</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/jp/" aria-label="日本語 (Japanese)" data-gtm-category="Header"
                                     data-gtm-action="Click" data-gtm-label="Language_日本語 (Japanese)" lang="en-us">日本語
                (Japanese)</a></li>
            </ul>
          </div><!--end_language_block--><!--start_support_block-->
          <div class="utility-dropdown" aria-label="Support Dropdown">
            <a href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" class="linkCta"
               lang="en-us" (click)="toggleDropdowns('openAboutDropdown')">About</a>
            <ul aria-hidden="true" class="utility-dropdown-data support" role="menu" [ngStyle]="{'display': openAboutDropdown ? 'block' : 'none'}">
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/en/about-us" data-gtm-category="Header" data-gtm-action="Support"
                                     data-gtm-label="Support_About Us" lang="en-us">About Us</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/en/about-us/our-services" data-gtm-category="Header"
                                     data-gtm-action="Support" data-gtm-label="Support_Our Services" lang="en-us">Our
                Services</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/en/media-center/news-announcements" data-gtm-category="Header"
                                     data-gtm-action="Support" data-gtm-label="Support_Media Center" lang="en-us">Media
                Center</a></li>
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/en/contact-us" data-gtm-category="Header" data-gtm-action="Support"
                                     data-gtm-label="Support_Contact Us" lang="en-us">Contact Us</a></li>
            </ul>
          </div><!--end_support_block-->    <!-- BEGINNING: molecules-user-dropdown-->


          <!-- BEGINNING: Register/Login menu -->
          <a id="navUserLogin" style="" href="https://www.spglobal.com/spdji/en/?enableLoginPopup=true"
             aria-label="Register / Login" class="header-link login" tabindex="0" data-gtm-category="Header"
             data-gtm-action="Click" data-gtm-label="Register / Login" lang="en-us">
            <span id="spRegisterLoginLabel">Register / Login</span>
            <picture aria-hidden="true">
              <source
                srcset="/assets/login.register.png 1x, /assets/login.register.-2x.png 2x"
                media="(min-width: 1360px)">
              <img srcset="/assets/login.register.png 1x, /assets/login.register.-2x.png 2x"
                   alt="">
            </picture>
          </a>

          <a id="navUserLogin" style="" href="https://www.spglobal.com/spdji/en/indices/products/login.html" aria-label="IHS Markit Login"
             class="header-link spRegisterLoginLink" tabindex="0" data-gtm-category="Header" data-gtm-action="Click"
             data-gtm-label="IHS Markit Login" lang="en-us">
            <span id="ihsRegisterLoginLabel">IHS Markit Login</span>
          </a>

          <!-- END: Register/Login menu -->
          <!-- BEGINNING: User Profile menu -->
          <div id="navUserPref" style="display: none;" class="utility-dropdown user login-register"
               aria-label="user Dropdown">
            <a href="#" aria-haspopup="true" aria-label="" aria-expanded="false" class="linkCta user-logged-in"
               lang="en-us">
              <span id="spUserName">Hi</span>
              <picture aria-hidden="true">
                <source
                  srcset="/assets/login.register.png 1x, /_assets/images/icons/login.register.-2x.png 2x"
                  media="(min-width: 1360px)">
                <img
                  srcset="/assets/login.register.png 1x, /_assets/images/icons/login.register.-2x.png 2x"
                  alt="">
              </picture>
            </a>
            <ul aria-hidden="true" class="utility-dropdown-data" role="menu">
              <li role="menuitem"><a href="https://www.spglobal.com/spdji/en/dashboard/account-settings/" lang="en-us">My
                Preferences</a></li>
              <li role="menuitem"><a class="lnk-log-out" href="javascript:void(0)" lang="en-us">Log out</a></li>
            </ul>
          </div>
          <!-- END: User Profile menu -->

          <script type="text/javascript">


            function userLoginActionResponse(jObj) {
              console.log("test: " + jObj.status);
              if (jObj.status) {
                $("#spUserName").text('Hi ' + jObj.firstName);
                $("#navUserPref").toggle();
              } else {
                $("#navUserLogin").toggle();
              }
            }

            function CallMethod(url, crossDomain, dataType, parameters, successCallback) {
              //console.log("CallMethod() " + url + " | " + crossDomain + " | " + dataType + " | " + parameters + " | " + successCallback);

              $.ajax({
                url: url,
                dataType: dataType,
                type: "post",
                data: parameters,
                crossDomain: crossDomain,
                jsonpCallback: successCallback,
                success: function (data, textStatus, jqXHR) {
                  //console.log("ajax call success!");
                },
                error: function (c, e, d) {
                  console.log("ajax call failed!");
                },
                complete: function (c, d) {
                }
              });
            }

            function logoutFunc() {
              window.location.href = 'https://www.spglobal.com/logout.do?end_url=' + encodeURI(window.location.href);
              return true;
            }

            $(document).ready(function (e) {
              var statusURL = 'https://www.spglobal.com/spdji/en/ids/protected/login.dot?callback=userLoginActionResponse&rnd=' + new Date().getTime();
              CallMethod(statusURL, true, "jsonp", {ssoFlag: true, skipFiltering: "true"}, "userLoginActionResponse");
              $(".lnk-log-out").click(function () {
                CallMethod('https://www.spglobal.com/spdji/en/ids/login/logout.dot', true, "jsonp", {}, "logoutFunc");
              });
            });
          </script><!-- END: molecules-user-dropdown--></div>
      </div>
    </div>
  </div><!--end_new_eyebrow-->
  <div class="navigation__wrapper">
    <a href="https://www.spglobal.com/spdji/en/" class="logo " data-gtm-category="Navigation" data-gtm-action="Main Navigation"
       data-gtm-label="S&amp;P Dow Jones Indices_Logo"
       target="" lang="en-us"
       [ngStyle]="{'transform': openedNavList === '' ? 'none' : 'matrix(1, 0, 0, 1, 0, 344.312)'}">
      <img class="logo__image" src="/assets/logo-spdji.png" alt="S&amp;P Dow Jones Indices"></a>
    <!-- PrimaryNav name: global_header_primary_nav index:  -->
    <style type="text/css">.nav-meta__event {
      padding-top: 10px;
    }

    .nav__secondary-list a {
      width: 17vw !important;
    }</style><!-- BEGINNING: molecules-primary-nav.twig -->
    <nav class="nav__primary " aria-label="">
      <ul class="nav__primary-list">
        <li [ngClass]="{'active': openedNavList === 'indices'}"><a href="#" data-gtm-category="Navigation"
                                                                   data-gtm-action="Main Navigation"
                                                                   data-gtm-label="Indices"
                                                                   (click)="openNavList($event,'indices')"
                                                                   class=" indices   " data-event-name="indices"
                                                                   lang="en-us" aria-expanded="false"
                                                                   aria-current="false">Indices</a>
        </li>
        <li [ngClass]="{'active': openedNavList === 'research'}"><a href="#" data-gtm-category="Navigation"
                                                                    data-gtm-action="Main Navigation"
                                                                    data-gtm-label="Research &amp; Insights"
                                                                    class=" research-and-insights   "
                                                                    (click)="openNavList($event,'research')"
                                                                    data-event-name="research-and-insights" lang="en-us"
                                                                    aria-expanded="false" aria-current="false">Research
          &amp; Insights</a></li>
        <li [ngClass]="{'active': openedNavList === 'exchange'}"><a href="#" data-gtm-category="Navigation"
                                                                    data-gtm-action="Main Navigation"
                                                                    data-gtm-label="Exchange Relationships"
                                                                    class=" exchange-relationships   "
                                                                    (click)="openNavList($event,'exchange')"
                                                                    data-event-name="exchange-relationships"
                                                                    lang="en-us" aria-expanded="false"
                                                                    aria-current="false">Exchange
          Relationships</a></li>
        <li [ngClass]="{'active': openedNavList === 'professional'}"><a href="#" data-gtm-category="Navigation"
                                                                        data-gtm-action="Main Navigation"
                                                                        data-gtm-label="Professional Resources"
                                                                        class=" professional-resources   "
                                                                        (click)="openNavList($event,'professional')"
                                                                        data-event-name="professional-resources"
                                                                        lang="en-us" aria-expanded="false"
                                                                        aria-current="false">Professional
          Resources</a></li>
        <li [ngClass]="{'active': openedNavList === 'governance'}"><a href="#" data-gtm-category="Navigation"
                                                                      data-gtm-action="Main Navigation"
                                                                      data-gtm-label="Governance"
                                                                      class=" governance   "
                                                                      data-event-name="governance" lang="en-us"
                                                                      aria-expanded="false"
                                                                      (click)="openNavList($event,'governance')"
                                                                      aria-current="false">Governance</a></li>
      </ul>
    </nav><!-- END: molecules-primary-nav.twig -->
    <button class="button__search" [ngClass]="{'open': searchOpened}" data-event-name="search" aria-label="search"
            data-gtm-category="Navigation"
            data-gtm-action="Main Navigation" data-gtm-label="Search" (click)="searchOpened = !searchOpened">
      <svg viewBox="0 0 17.5 17.5">
        <path
          d="M12.5,11h-0.8l-0.3-0.3c1-1.1,1.6-2.6,1.6-4.2C13,2.9,10.1,0,6.5,0S0,2.9,0,6.5S2.9,13,6.5,13c1.6,0,3.1-0.6,4.2-1.6l0.3,0.3v0.8l5,5l1.5-1.5L12.5,11z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11z"></path>
      </svg>
      <span></span> <span></span></button>
    <div class="navigation__burger-wrapper">
      <button class="button__menu js-select-dispatch" data-event-name="hamburger-menu" aria-label="mobile-menu">
        <span></span> <span></span> <span></span></button>
    </div>
  </div>
  <div class="navigation__mobile-wrapper js-navigation-mobile">
    <ul class="vertical menu" data-accordion-menu="">

      <li>
        <a href="#" lang="en-us">
          Indices
          <button aria-hidden="true" class="button__accordion"><span></span><span></span></button>
        </a>
        <ul class="menu vertical nested">
          <span class="nav__secondary-category">By Category</span>
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/index-family/equity/" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Equity" lang="en-us">Equity </a></li>
            <li><a href="/spdji/en/index-family/fixed-income/" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Fixed Income" lang="en-us">Fixed
              Income </a></li>
            <li><a href="/spdji/en/index-family/commodities" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Commodities" lang="en-us">Commodities </a>
            </li>
            <li><a href="/spdji/en/index-family/strategy" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Strategy" lang="en-us">Strategy </a></li>
            <li><a href="/spdji/en/index-family/multi-asset" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Multi-Asset" lang="en-us">Multi-Asset </a>
            </li>
          </ul>
          <span class="nav__secondary-category">&nbsp;</span>
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/index-family/esg/" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_ESG" lang="en-us">ESG </a></li>
            <li><a href="/spdji/en/index-family/thematics/" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Thematics" lang="en-us">Thematics </a></li>
            <li><a href="/spdji/en/index-family/digital-assets" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Digital Assets" lang="en-us">Digital
              Assets </a></li>
            <li><a href="/spdji/en/index-family/indicators" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Indicators" lang="en-us">Indicators </a>
            </li>
            <li><a href="/spdji/en/custom-indices/solutions" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Custom Solutions" lang="en-us">Custom
              Solutions </a></li>
          </ul>
          <span class="nav__secondary-category">By Region</span>
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/regional-exposure/global" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Global" lang="en-us">Global </a></li>
            <li><a href="/spdji/en/regional-exposure/americas" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Americas" lang="en-us">Americas </a></li>
            <li><a href="/spdji/en/regional-exposure/europe" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Europe" lang="en-us">Europe </a></li>
            <li><a href="/spdji/en/regional-exposure/middle-east-africa" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Middle East &amp; Africa" lang="en-us">Middle
              East &amp; Africa </a></li>
            <li><a href="/spdji/en/regional-exposure/asia-pacific" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Indices_Asia Pacific" lang="en-us">Asia
              Pacific </a></li>
          </ul>
          <span class="nav__secondary-category MenuSecNavBgInner">IHS MARKIT INDICES</span>
          <ul class="nav__secondary__category-list MenuSecNavBgInner">
            <li><a href="https://ihsmarkit.com/products/iboxx.html" target="_blank" class=""
                   data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Indices_iBoxx Bond &amp; Loan Indices" lang="en-us">iBoxx Bond &amp; Loan Indices<i
              class="fa fa-external-link" aria-hidden="true"></i> </a></li>
            <li><a href="https://ihsmarkit.com/products/esg-sustainable-indices.html" target="_blank" class=""
                   data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Indices_ESG/Sustainable Indices" lang="en-us">ESG/Sustainable Indices<i
              class="fa fa-external-link" aria-hidden="true"></i> </a></li>
            <li><a href="https://ihsmarkit.com/products/cds-indices.html" target="_blank" class=""
                   data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Indices_Credit Default Swap Indices" lang="en-us">Credit Default Swap Indices<i
              class="fa fa-external-link" aria-hidden="true"></i> </a></li>
            <li><a href="https://ihsmarkit.com/products/cambridge-associates-private-investment-benchmarks.html"
                   target="_blank" class="" data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Indices_Private Investment Benchmarks" lang="en-us">Private Investment Benchmarks<i
              class="fa fa-external-link" aria-hidden="true"></i> </a></li>
          </ul>
          <!-- SecondaryLeftLinkBottom name: global_header_primary_nav_panel_primary_nav_secondary_nav_panel_secondary_links_link_bottom index: :4:1 --><a
          href="https://ihsmarkit.com/products/indices.html" class="nav__secondary-link MenuSecNavBgInner"
          data-gtm-category="Navigation" data-gtm-action="Main Navigation"
          data-gtm-label="Indices_See All IHS Markit Solutions" lang="en-us">See All IHS Markit Solutions</a>
        </ul>
      </li>
      <li>
        <a href="#" lang="en-us">
          Research &amp; Insights
          <button aria-hidden="true" class="button__accordion"><span></span><span></span></button>
        </a>
        <ul class="menu vertical nested">
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/research-insights" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Overview" lang="en-us">Overview </a>
            </li>
            <li><a href="/spdji/en/research-insights/research" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Research" lang="en-us">Research </a>
            </li>
            <li><a href="/spdji/en/research-insights/commentary" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Commentary" lang="en-us">Commentary </a>
            </li>
            <li><a href="/spdji/en/research-insights/education" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Education" lang="en-us">Education </a>
            </li>
            <li><a href="/spdji/en/research-insights/performance-reports" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Performance Reports"
                   lang="en-us">Performance Reports </a></li>
          </ul>
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/research-insights/spiva" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_SPIVA"
                   lang="en-us">SPIVA </a></li>
            <li><a href="/spdji/en/investment-themes/overview" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Investment Themes"
                   lang="en-us">Investment Themes </a></li>
            <li><a href="https://www.indexologyblog.com/" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Blog"
                   lang="en-us">Blog </a></li>
            <li><a href="/spdji/en/events/webinars" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Events"
                   lang="en-us">Events </a></li>
            <li><a href="/spdji/en/research-insights/index-tv" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Index TV" lang="en-us">Index
              TV </a></li>
          </ul>
        </ul>
      </li>
      <li>
        <a href="#" lang="en-us">
          Exchange Relationships
          <button aria-hidden="true" class="button__accordion"><span></span><span></span></button>
        </a>
        <ul class="menu vertical nested">
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/exchange-relationships" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_Overview" lang="en-us">Overview </a>
            </li>
            <li><a href="/spdji/en/exchange-relationships/#north-america" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_North America" lang="en-us">North
              America </a></li>
            <li><a href="/spdji/en/exchange-relationships/#latin-america" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_Latin America" lang="en-us">Latin
              America </a></li>
            <li><a href="/spdji/en/exchange-relationships/#emea" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_EMEA" lang="en-us">EMEA </a>
            </li>
            <li><a href="/spdji/en/exchange-relationships/#asia-pacific" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_Asia Pacific" lang="en-us">Asia
              Pacific </a></li>
          </ul>
        </ul>
      </li>
      <li>
        <a href="#" lang="en-us">
          Professional Resources
          <button aria-hidden="true" class="button__accordion"><span></span><span></span></button>
        </a>
        <ul class="menu vertical nested">
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/landing/professional-resources/financial-advisors" class=""
                   data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Professional Resources_Financial Advisors" lang="en-us">Financial Advisors </a></li>
            <li><a href="/spdji/en/landing/professional-resources/insurance" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Professional Resources_Insurance" lang="en-us">Insurance </a>
            </li>
            <li><a href="/spdji/en/landing/professional-resources/institutional-investors" class=""
                   data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Professional Resources_Institutional Investors" lang="en-us">Institutional
              Investors </a></li>
            <li><a href="/spdji/en/landing/professional-resources/defined-contribution" class=""
                   data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Professional Resources_Defined Contribution" lang="en-us">Defined Contribution </a>
            </li>
          </ul>
        </ul>
      </li>
      <li>
        <a href="#" lang="en-us">
          Governance
          <button aria-hidden="true" class="button__accordion"><span></span><span></span></button>
        </a>
        <ul class="menu vertical nested">
          <ul class="nav__secondary__category-list">
            <li><a href="/spdji/en/governance" class="" data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                   data-gtm-label="Governance_Overview" lang="en-us">Overview </a></li>
            <li><a href="/spdji/en/governance/regulatory-information" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Governance_Regulatory Information" lang="en-us">Regulatory
              Information </a></li>
            <li><a href="/spdji/en/governance/methodologies" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Governance_Methodologies" lang="en-us">Methodologies </a>
            </li>
            <li><a href="/spdji/en/governance/consultations" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Governance_Consultations" lang="en-us">Consultations </a>
            </li>
            <li><a href="/spdji/en/governance/corporate-engagement" class="" data-gtm-category="Navigation"
                   data-gtm-action="Main Navigation" data-gtm-label="Governance_Corporate Engagement" lang="en-us">Corporate
              Engagement </a></li>
          </ul>
        </ul>
      </li>
    </ul>
    <ul class="menu vertical site-nav--accordion"></ul>
  </div>
  <div class="navigation_secondary__wrapper--search js-search navigation_secondary__wrapper--search-spdji"
       [ngClass]="{'open': searchOpened}"
       [ngStyle]="{'display': searchOpened ? 'block' : 'none'}" data-paired-event="search" role="search">
    <div class="search-input__wrapper">       <!-- BEGINNING: Search Block -->
      <form id="search-form" action="https://www.spglobal.com/spdji/en/search/">
        <div class="search-input-wrapper global-search">
          <input type="text" name="query" placeholder="SEARCH BY KEYWORD" [(ngModel)]="searchTerm" (keypress)="runSearch($event)">
          <span class="search-input__svg" (click)="runSearch($event)">				<svg data-gtm-action="Main Navigation" data-gtm-category="Navigation"
                                                       data-gtm-label="Search" viewBox="0 0 17.5 17.5">					<path
            d="M12.5,11h-0.8l-0.3-0.3c1-1.1,1.6-2.6,1.6-4.2C13,2.9,10.1,0,6.5,0S0,2.9,0,6.5S2.9,13,6.5,13c1.6,0,3.1-0.6,4.2-1.6l0.3,0.3v0.8l5,5l1.5-1.5L12.5,11z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11z"></path>				</svg>			</span>
          <div class="index-finder"><a class="button-white arrow" data-gtm-action="Main Navigation"
                                       data-gtm-category="Navigation" data-gtm-label="Search"
                                       href="https://www.spglobal.com/spdji/en/index-finder/" lang="en-us"><span>Index Finder</span></a>
          </div>
        </div>
      </form><!-- END: End Search Block -->    </div>
  </div>
  <div class="navigation_secondary__wrapper js-secondary-nav header-four-column"
       [ngClass]="{'open-wrapper': openedNavList !== ''}" (mouseleave)="openNavList($event, '')">
    <ul class="navigation_secondary__list">
      <li data-nav-id="indices" id="indices" class="menu-set-control"
          [ngClass]="{'active': openedNavList === 'indices'}"><!-- BEGINNING: molecules-secondary-nav.twig -->
        <nav class="nav__secondary four-column">
          <div class="nav__secondary-list four-column "><span class="nav__secondary-category">By Category</span>
            <ul class="nav__secondary__category-list" aria-label="By Category">
              <li><a href="https://www.spglobal.com/spdji/en/index-family/equity/" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Equity" lang="en-us">Equity </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/fixed-income/" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Fixed Income" lang="en-us">Fixed
                Income </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/commodities" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Commodities"
                     lang="en-us">Commodities </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/strategy" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Strategy" lang="en-us">Strategy </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/multi-asset" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Multi-Asset"
                     lang="en-us">Multi-Asset </a></li>
            </ul>
          </div>
          <div class="nav__secondary-list four-column "><span class="nav__secondary-category">&nbsp;</span>
            <ul class="nav__secondary__category-list" aria-label="&nbsp;">
              <li><a href="https://www.spglobal.com/spdji/en/index-family/esg/" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_ESG" lang="en-us">ESG </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/thematics/" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Thematics" lang="en-us">Thematics </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/digital-assets" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Digital Assets" lang="en-us">Digital
                Assets </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/index-family/indicators" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Indicators" lang="en-us">Indicators </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/custom-indices/solutions" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Custom Solutions" lang="en-us">Custom
                Solutions </a></li>
            </ul>
          </div>
          <div class="nav__secondary-list four-column "><span class="nav__secondary-category">By Region</span>
            <ul class="nav__secondary__category-list" aria-label="By Region">
              <li><a href="https://www.spglobal.com/spdji/en/regional-exposure/global" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Global" lang="en-us">Global </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/regional-exposure/americas" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Americas" lang="en-us">Americas </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/regional-exposure/europe" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Europe" lang="en-us">Europe </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/regional-exposure/middle-east-africa" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Middle East &amp; Africa" lang="en-us">Middle
                East &amp; Africa </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/regional-exposure/asia-pacific" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Indices_Asia Pacific" lang="en-us">Asia
                Pacific </a></li>
            </ul>
          </div>
          <div class="nav__secondary-list MenuSecNavBg four-column "><span
            class="nav__secondary-category MenuSecNavBgInner">IHS MARKIT INDICES</span>
            <ul class="nav__secondary__category-list MenuSecNavBgInner" aria-label="IHS MARKIT INDICES">
              <li><a href="https://ihsmarkit.com/products/iboxx.html" target="_blank" class=""
                     data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Indices_iBoxx Bond &amp; Loan Indices" lang="en-us">iBoxx Bond &amp; Loan Indices<i
                class="fa fa-external-link" aria-hidden="true"></i> </a></li>
              <li><a href="https://ihsmarkit.com/products/esg-sustainable-indices.html" target="_blank" class=""
                     data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Indices_ESG/Sustainable Indices" lang="en-us">ESG/Sustainable Indices<i
                class="fa fa-external-link" aria-hidden="true"></i> </a></li>
              <li><a href="https://ihsmarkit.com/products/cds-indices.html" target="_blank" class=""
                     data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Indices_Credit Default Swap Indices" lang="en-us">Credit Default Swap Indices<i
                class="fa fa-external-link" aria-hidden="true"></i> </a></li>
              <li><a href="https://ihsmarkit.com/products/cambridge-associates-private-investment-benchmarks.html"
                     target="_blank" class="" data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Indices_Private Investment Benchmarks" lang="en-us">Private Investment Benchmarks<i
                class="fa fa-external-link" aria-hidden="true"></i> </a></li>
            </ul>
            <!-- SecondaryLeftLinkBottom name: global_header_primary_nav_panel_primary_nav_secondary_nav_panel_secondary_links_link_bottom index: :4:1 --><a
              href="https://ihsmarkit.com/products/indices.html" class="nav__secondary-link MenuSecNavBgInner"
              data-gtm-category="Navigation" data-gtm-action="Main Navigation"
              data-gtm-label="Indices_See All IHS Markit Solutions" lang="en-us">See All IHS Markit Solutions</a></div>
        </nav><!-- END: molecules-secondary-nav.twig -->
      </li>
      <li data-nav-id="research-and-insights" id="research-and-insights" class="menu-set-control"
          [ngClass]="{'active': openedNavList === 'research'}">
        <!-- BEGINNING: molecules-secondary-nav.twig -->
        <nav class="nav__secondary two-column">
          <div class="nav__secondary-list  wd-25 ">
            <ul class="nav__secondary__category-list" aria-label="">
              <li><a href="https://www.spglobal.com/spdji/en/research-insights" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Overview" lang="en-us">Overview </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/research-insights/research" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Research" lang="en-us">Research </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/research-insights/commentary" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Commentary" lang="en-us">Commentary </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/research-insights/education" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Education" lang="en-us">Education </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/research-insights/performance-reports" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Performance Reports"
                     lang="en-us">Performance Reports </a></li>
            </ul>
          </div>
          <div class="nav__secondary-list  wd-25 ">
            <ul class="nav__secondary__category-list" aria-label="">
              <li><a href="https://www.spglobal.com/spdji/en/research-insights/spiva" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_SPIVA"
                     lang="en-us">SPIVA </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/investment-themes/overview" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Investment Themes"
                     lang="en-us">Investment Themes </a></li>
              <li><a href="https://www.indexologyblog.com/" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Blog"
                     lang="en-us">Blog </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/events/webinars" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Events" lang="en-us">Events </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/research-insights/index-tv" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Research &amp; Insights_Index TV" lang="en-us">Index
                TV </a></li>
            </ul>
          </div>
          <div class="nav-meta__event"><span class="nav-meta__event-category"></span>
            <div class="nav-meta__event-column"><span class="nav__secondary-category">STAY CONNECTED</span><a
              class="nav-meta__event-label" href="https://on.spdji.com/SignUp?src=IDS" target="_self" lang="en-us">Get our latest research and insights in
              your inbox.</a><a class="nav-meta__latest-cta link-with-arrow link-red-hover"
                                href="https://on.spdji.com/SignUp?src=IDS" target="_self" lang="en-us">Sign Up</a></div>
            <div class="nav-meta__event-column"><span class="nav__secondary-category">INDEX DASHBOARDS</span><a
              class="nav-meta__event-label" href="https://www.spglobal.com/spdji/en/research-insights/performance-reports/" target="_self" lang="en-us">
              Performance Analytics at a Glance</a><a
              class="nav-meta__latest-cta link-with-arrow link-red-hover"
              href="https://www.spglobal.com/spdji/en/research-insights/performance-reports" target="_self"
              lang="en-us">Access the Latest Dashboards</a></div>
          </div>
        </nav><!-- END: molecules-secondary-nav.twig -->
      </li>
      <li data-nav-id="exchange-relationships" id="exchange-relationships"
          [ngClass]="{'active': openedNavList === 'exchange'}">
        <!-- BEGINNING: molecules-secondary-nav.twig -->
        <nav class="nav__secondary one-column">
          <div class="nav__secondary-list   ">
            <ul class="nav__secondary__category-list" aria-label="">
              <li><a href="https://www.spglobal.com/spdji/en/exchange-relationships" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_Overview" lang="en-us">Overview </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/exchange-relationships/#north-america" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_North America"
                     lang="en-us">North America </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/exchange-relationships/#latin-america" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_Latin America"
                     lang="en-us">Latin America </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/exchange-relationships/#emea" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_EMEA"
                     lang="en-us">EMEA </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/exchange-relationships/#asia-pacific" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Exchange Relationships_Asia Pacific"
                     lang="en-us">Asia Pacific </a></li>
            </ul>
          </div>
          <div class="nav-meta__event"><span class="nav-meta__event-category"></span></div>
        </nav><!-- END: molecules-secondary-nav.twig -->
      </li>
      <li data-nav-id="professional-resources" id="professional-resources"
          [ngClass]="{'active': openedNavList === 'professional'}">
        <!-- BEGINNING: molecules-secondary-nav.twig -->
        <nav class="nav__secondary one-column">
          <div class="nav__secondary-list   ">
            <ul class="nav__secondary__category-list" aria-label="">
              <li><a href="https://www.spglobal.com/spdji/en/landing/professional-resources/financial-advisors" class=""
                     data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Professional Resources_Financial Advisors" lang="en-us">Financial Advisors </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/landing/professional-resources/insurance" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Professional Resources_Insurance" lang="en-us">Insurance </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/landing/professional-resources/institutional-investors" class=""
                     data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Professional Resources_Institutional Investors" lang="en-us">Institutional
                Investors </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/landing/professional-resources/defined-contribution" class=""
                     data-gtm-category="Navigation" data-gtm-action="Main Navigation"
                     data-gtm-label="Professional Resources_Defined Contribution" lang="en-us">Defined Contribution </a>
              </li>
            </ul>
          </div>
          <div class="nav-meta__event"><span class="nav-meta__event-category"></span>
            <div class="nav-meta__event-column"><span class="nav__secondary-category">INDEX-LINKED PRODUCTS</span><a
              class="nav-meta__event-label" href="https://www.spglobal.com/spdji/en/index-linked-products/" target="_self" lang="en-us">Explore products linked to our
              indices.</a><a class="nav-meta__latest-cta link-with-arrow link-red-hover"
                             href="https://www.spglobal.com/spdji/en/index-linked-products/" target="_self"
                             lang="en-us">Find Products</a></div>
          </div>
        </nav><!-- END: molecules-secondary-nav.twig -->
      </li>
      <li data-nav-id="governance" id="governance" [ngClass]="{'active': openedNavList === 'governance'}">
        <!-- BEGINNING: molecules-secondary-nav.twig -->
        <nav class="nav__secondary one-column">
          <div class="nav__secondary-list   ">
            <ul class="nav__secondary__category-list" aria-label="">
              <li><a href="https://www.spglobal.com/spdji/en/governance" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Governance_Overview" lang="en-us">Overview </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/governance/regulatory-information" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Governance_Regulatory Information" lang="en-us">Regulatory
                Information </a></li>
              <li><a href="https://www.spglobal.com/spdji/en/governance/methodologies" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Governance_Methodologies" lang="en-us">Methodologies </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/governance/consultations" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Governance_Consultations" lang="en-us">Consultations </a>
              </li>
              <li><a href="https://www.spglobal.com/spdji/en/governance/corporate-engagement" class="" data-gtm-category="Navigation"
                     data-gtm-action="Main Navigation" data-gtm-label="Governance_Corporate Engagement" lang="en-us">Corporate
                Engagement </a></li>
            </ul>
          </div>
          <div class="nav-meta__event"><span class="nav-meta__event-category"></span>
            <div class="nav-meta__event-column"><span class="nav__secondary-category">METHODOLOGY INFO</span><a
              class="nav-meta__event-label" href="https://www.spglobal.com/spdji/en/landing/topic/gics/" target="_self" lang="en-us">GICS<sup>®</sup>: Global Industry
              Classification Standard</a><a class="nav-meta__latest-cta link-with-arrow link-red-hover"
                                            href="https://www.spglobal.com/spdji/en/landing/topic/gics" target="_self"
                                            lang="en-us">Explore</a></div>
            <div class="nav-meta__event-column"><span class="nav__secondary-category">METHODOLOGY INFO</span><a
              class="nav-meta__event-label" href="https://www.spglobal.com/spdji/en/landing/topic/market-classification/?utm_medium=next_gen&utm_source=google&utm_campaign=paid_campaign&utm_term=s&p&dow&jones&indices&llc&utm_content=Intl_SPDJI_Brand&gclid=Cj0KCQjwpeaYBhDXARIsAEzItbGuZSDTeVrC38qint-hlqNlLXqpXeeMLF8xgc0O2JSRgUc5RuvRULgaAn3tEALw_wcB"
              target="_self" lang="en-us">S&amp;P DJI Market Classification</a><a
              class="nav-meta__latest-cta link-with-arrow link-red-hover"
              href="https://www.spglobal.com/spdji/en/landing/topic/market-classification/" target="_self" lang="en-us">LEARN
              MORE</a></div>
            <div class="nav-meta__event-column"><span class="nav__secondary-category">IHS MARKIT</span><a
              class="nav-meta__event-label" href="https://www.markit.com/Documentation/Product/Indices" target="_self" lang="en-us">View methodologies, annexes, guides and
              legal documents.</a><a class="nav-meta__latest-cta link-with-arrow link-red-hover"
                                     href="https://www.markit.com/Documentation/Product/Indices" target="_self"
                                     lang="en-us">ACCESS DOCUMENTATION</a></div>
          </div>
        </nav><!-- END: molecules-secondary-nav.twig -->
      </li>
    </ul>
  </div>
</div>
